import React from "react";

const promos = [
  {
    icon: "/assets/img/icon-reclutamiento.png",
    title: "Reclutamiento Puro",
    description:
      "Nos encargamos de encontrar al mejor talento para cualquier área de tu empresa: Recursos Humanos, Compras, Logistica, Comercial, Marketing, Contabilidad y Finanzas.  Invierte tu tiempo en candidatos previamente calificados por nuestro equipo.",
  },
  {
    icon: "/assets/img/icon-operativo.png",
    title: "Reclutamiento Masivo",
    description:
      "¿Cuentas con 20, 40, 60 vacantes de un mismo puesto? Por Temporalidades, Nuevas líneas de producción, arranques de planta, cubrir rotación. Somos expertos en generar el flujo de candidatos para cubrir tus vacantes operativas ofreciendo soluciones integrales.",
  },
  {
    icon: "/assets/img/icon-headhunting.png",
    title: "Headhunting",
    description:
      "Talento Calificado para puestos calve de tu organización. Mediante una búsqueda activa Identificamos, atraemos y convencemos al talento que, en la mayoría de los casos, no se encuentran buscando empleo.",
  },
];

const Nosotros = () => {
  return (
    <section id="Nosotros" className="promo-section ptb-100">
      <div className="container">
        {/* Encabezado */}
        <div className="row justify-content-center">
          <div className="col-lg-7 col-md-8">
            <div className="section-heading text-center mb-5">
              <h2>¿Por qué confiar en SELEKTIANDO?</h2>
              <p className="lead">
                Optimizamos cada etapa del reclutamiento con IA para que tu
                empresa encuentre el talento ideal, más rápido y con mejores
                resultados.
              </p>
            </div>
          </div>
        </div>

        {/* Promos */}
        <div className="row equal">
          {promos.map((promo, index) => (
            <div className="col-md-4 col-lg-4" key={index}>
              <div className="single-promo single-promo-hover single-promo-1 rounded text-center white-bg p-5 h-100">
                <div
                  className="circle-icon mb-5 position-relative mx-auto"
                  style={{
                    backgroundColor: "#2999f2",
                    borderRadius: "50%",
                    width: "90px",
                    height: "90px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={promo.icon}
                    alt={promo.title}
                    style={{
                      maxWidth: "48px",
                      maxHeight: "48px",
                      filter: "brightness(0) invert(1)",
                      position: "relative",
                      top: "0.5px", // <-- aquí puedes ajustar fino para que se vea óptico-centrado
                    }}
                  />
                </div>

                <h5 style={{ fontWeight: "600" }}>{promo.title}</h5>
                <p style={{ color: "#6c757d" }}>{promo.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Nosotros;
